import { EntityAudit } from "@modernary/mui/components/audit";
import { EntityDocuments } from "@modernary/mui/components/document";
import { EntityNotes } from "@modernary/mui/components/note";
import { RouterView, type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  items: "OutboxItem.Items",
  list: "OutboxItem.ItemList",
  new: "OutboxItem.ItemNew",
  base: "OutboxItem.ItemBase",
  view: "OutboxItem.ItemView",
  edit: "OutboxItem.ItemEdit",
  notes: "OutboxItem.ItemNotes",
  noteEdit: "OutboxItem.ItemNoteEdit",
  noteNew: "OutboxItem.ItemNoteNew",
  // documents: "OutboxItem.ItemDocuments",
  // documentsEdit: "OutboxItem.ItemDocumentsEdit",
  // documentsNew: "OutboxItem.ItemDocumentsNew",
  workFlowTasks: "OutboxItem.ItemWorkFlowTasks",
  workFlowTaskEdit: "OutboxItem.ItemWorkFlowTaskEdit",
  workFlowTaskNew: "OutboxItem.ItemWorkFlowTaskNew",
  audit: "OutboxItem.ItemAudit",
};

export { names as outboxItemRouteNames };

const outboxItemRoutes: RouterOptions["routes"] = [
  {
    path: "/outboxItem",
    name: names.items,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Outbox Items" },
        component: () => import("@/views/outboxItem/OutboxItemList.vue"),
      },
      {
        path: "new",
        component: () => import("@/views/outboxItem/OutboxItemBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "New Outbox Item", isNew: true },
            component: () => import("@/views/outboxItem/OutboxItemEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/outboxItem/OutboxItemBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Outbox Item View" },
            component: () => import("@/views/outboxItem/OutboxItemView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Outbox Item Edit", isForm: true },
            component: () => import("@/views/outboxItem/OutboxItemEdit.vue"),
          },
          {
            path: "workFlowTasks",
            name: names.workFlowTasks,
            meta: { title: "Outbox Item Workflow Task", lookupGroups: ["TaskStatus", "TaskPriority", "Employee"] },
            component: () => import("@/views/outboxItem/WorkFlowTasksChildList.vue"),
          },
          {
            path: "workFlowTasks/:workFlowTaskId(\\d+)",
            name: names.workFlowTaskEdit,
            meta: { title: "Edit Outbox Item Workflow Task", isForm: true },
            component: () => import("@/views/outboxItem/OutboxItemWorkFlowTask.vue"),
          },
          {
            path: "workFlowTasks/new",
            name: names.workFlowTaskNew,
            meta: { title: "Create Outbox Item Workflow Task", isForm: true },
            component: () => import("@/views/outboxItem/OutboxItemWorkFlowTask.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Outbox Item Notes" },
            component: {
              render: () => <EntityNotes idField="mailItemId" routeNamePrefix="OutboxItem.ItemNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Edit Outbox Item Note", isForm: true },
            component: () => import("@/views/outboxItem/OutboxItemNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Create Outbox Item Note", isForm: true },
            component: () => import("@/views/outboxItem/OutboxItemNote.vue"),
          },
          // {
          //   path: "documents",
          //   name: names.documents,
          //   meta: { title: "Outbox Item Documents" },
          //   component: {
          //     render: () => <EntityDocuments idField="mailItemId" routeNamePrefix="OutboxItem.ItemDocuments" />,
          //   },
          // },
          // {
          //   path: "documents/:documentId(\\d+)",
          //   name: names.documentsEdit,
          //   meta: { title: "Edit Outbox Item Document", isForm: true },
          //   component: () => import("@/views/outboxItem/OutboxDocument.vue"),
          // },
          // {
          //   path: "documents/new",
          //   name: names.documentsNew,
          //   meta: { title: "Create Outbox Item Documents", isForm: true },
          //   component: () => import("@/views/outboxItem/OutboxDocuments.vue"),
          // },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Outbox Item Audit Activity" },
            component: {
              render: () => <EntityAudit entityType="Item" />,
            },
          },
        ],
      },
    ],
  },
];
export default outboxItemRoutes;
